import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";

/**
 * Gesto iOS de "voltar": arrastar da borda esquerda para a direita.
 * Só ativa em telas touch/mobile e quando existe histórico interno.
 */
export function useSwipeBack(enabled = true) {
  const router = useRouter();

  useEffect(() => {
    if (!enabled) return;
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(max-width: 1023px), (pointer: coarse)").matches) return;

    let startX = 0;
    let startY = 0;
    let tracking = false;

    const onStart = (e: TouchEvent) => {
      const t = e.touches[0];
      if (!t) return;
      tracking = t.clientX <= 28;
      startX = t.clientX;
      startY = t.clientY;
    };

    const onEnd = (e: TouchEvent) => {
      if (!tracking) return;
      tracking = false;
      const t = e.changedTouches[0];
      if (!t) return;
      const dx = t.clientX - startX;
      const dy = Math.abs(t.clientY - startY);
      if (dx > 90 && dy < 70) {
        try {
          if (router.history.length > 1) router.history.back();
        } catch {
          /* noop */
        }
      }
    };

    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchend", onEnd);
    };
  }, [enabled, router]);
}
